import React, { useState } from 'react'
import Input from '../../../FormComponents/Input'
import FileDropzone from '../../../FormComponents/FileDropzone'
import { FileEarmarkPlus, Trash } from 'react-bootstrap-icons'

export default function NewClientAddContact({
  edit,
  editableContact,
  index,
  addToClientContacts,
  updateClientContacts,
  deleteClientContact,
  setShowAddContact,
}) {
  const [src, setSrc] = useState(editableContact?.avatar && (typeof editableContact.avatar === 'string' ? editableContact.avatar : URL.createObjectURL(editableContact.avatar)))
  const [contactName, setContactName] = useState(editableContact?.name || '')
  const [contactPhone, setContactPhone] = useState(editableContact?.phone || '')
  const [contactEmail, setContactEmail] = useState(editableContact?.email || '')
  const [contactNotes, setContactNotes] = useState(editableContact?.notes || '')
  const [contactAvatar, setContactAvatar] = useState(editableContact?.avatar || null)


  const handleAddUpdateSubmit = () => {
    const newContact = {
      id: editableContact?.id,
      name: contactName,
      phone: contactPhone,
      email: contactEmail,
      notes: contactNotes,
      avatar: contactAvatar,
    }

    if (edit) {
      updateClientContacts(newContact, index)
    } else {
      addToClientContacts(newContact)
    }

    setShowAddContact(false)
  }

  const removeContact = () => {
    deleteClientContact(index)
    setShowAddContact(false)
  }

  return (
    <div>
      <div className="flex justify-start items-center pb-4">
        <h2>{edit ? 'Update Contact' : 'Create New Contact'}</h2>
      </div>
      <div className="w-full">
        <Input noLabelPadding label="Name" placeholder="Name" name='name' onChange={(e) => setContactName(e.target.value)} defaultValue={editableContact && editableContact.name} />
        <Input noLabelPadding label="E-mail address" placeholder="Email" name="email" onChange={(e) => setContactEmail(e.target.value)} defaultValue={editableContact && editableContact.email} />
        <Input noLabelPadding label="Phone number" placeholder="Phone" name='phone' onChange={(e) => setContactPhone(e.target.value)} defaultValue={editableContact && editableContact.phone} />

        <span className="label">Note</span>
        <textarea
          name='notes'
          placeholder="Write a note"
          rows="4"
          cols="40"
          className='
                mb-4
                border-1
                border-rb-lite-grey
                focus-visible:outline-0
                focus-visible:border-rb-green
                focus-visible:border-2
                focus:outline-0
                focus:ring-transparent
                focus:ring-offset-transparent
                ring-transparent
                ring-offset-transparent
                rounded-lg
                w-full'
          onChange={(e) => setContactNotes(e.target.value)}
          defaultValue={editableContact && editableContact.notes}
        />
        <span className="label">Contact Avatar</span>
        <FileDropzone uploadFiles={files => {
          setSrc(URL.createObjectURL(files[0]))
          setContactAvatar(files[0])
        }}
          icon={<FileEarmarkPlus />}
        />
        <div className={`w-full flex justify-center ${src && 'py-6' || 'py-1'}`}>
          {src && <img className="h-20 w-20 rounded-3xl" src={src} />}
        </div>
        <div className="flex justify-between mt-5">
          <button
            className='rb-btn-cancel flex items-center font-bold text-md p-2 px-4 rounded-lg'
            onClick={() => edit ? removeContact(index) : setShowAddContact(false)}
          >
            {edit && <Trash />}
            <span className="ml-1">{edit ? 'Delete contact' : 'Cancel'}</span>
          </button>

          <button
            type="button"
            className={`${edit ? '' : 'ml-auto '}submit text-white bg-rb-green border-2 rounded-lg px-4 py-2 text-center active:shadow-outer active:shadow-rb-green border-rb-green`}
            onClick={() => {
              handleAddUpdateSubmit()
            }}
          >
            {edit ? 'Update Contact' : 'Add contact'}
          </button>
        </div>
      </div>
    </div>
  )
}
